import * as React from "react";

const MOBILE_BREAKPOINT = 768;
const SM_BREAKPOINT = 640;
const LG_BREAKPOINT = 1024;

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(undefined);

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
    const onChange = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    };
    mql.addEventListener("change", onChange);
    setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return !!isMobile;
}

/** Matches Tailwind `lg:` — desktop split-panel layout at 1024px+. */
export function useIsLg() {
  const [isLg, setIsLg] = React.useState(
    () => typeof window !== "undefined" && window.innerWidth >= LG_BREAKPOINT,
  );

  React.useEffect(() => {
    const mql = window.matchMedia(`(min-width: ${LG_BREAKPOINT}px)`);
    const onChange = () => {
      setIsLg(window.innerWidth >= LG_BREAKPOINT);
    };
    mql.addEventListener("change", onChange);
    setIsLg(window.innerWidth >= LG_BREAKPOINT);
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return isLg;
}

/** Matches Tailwind `sm:` — 640px and up. */
export function useIsSm() {
  const [isSm, setIsSm] = React.useState(
    () => typeof window !== "undefined" && window.innerWidth >= SM_BREAKPOINT,
  );

  React.useEffect(() => {
    const mql = window.matchMedia(`(min-width: ${SM_BREAKPOINT}px)`);
    const onChange = () => {
      setIsSm(window.innerWidth >= SM_BREAKPOINT);
    };
    mql.addEventListener("change", onChange);
    setIsSm(window.innerWidth >= SM_BREAKPOINT);
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return isSm;
}
